
import { AddFreeSubscription } from '@/modules/free-subscriptions/types'
import { defineComponent, reactive, ref } from 'vue'
import FreeSubscriptionsFormFieldMember from '@/components/free-subscriptions/form-fields/member.vue'
import FreeSubscriptionsFormFieldStartDate from '@/components/free-subscriptions/form-fields/start-date.vue'
import FreeSubscriptionsFormFieldEndDate from '@/components/free-subscriptions/form-fields/end-date.vue'
import FreeSubscriptionsFormFieldSubscriptionType from '@/components/free-subscriptions/form-fields/subscription-type.vue'
import FreeSubscriptionsFormFieldProcessType from '@/components/free-subscriptions/form-fields/process-type.vue'
import FormFieldPackages from '@/components/_shared/form-fields/packages.vue'
import FreeSubscriptionPickMemberDialog from '@/components/free-subscriptions/dialogs/pick-member.vue'
import FreeSubscriptionNewMemberDialog from '@/components/free-subscriptions/dialogs/new-member.vue'
import FreeSubscriptionSearchForMemberDialog from '@/components/free-subscriptions/dialogs/search-for-member.vue'
import { FreeSubscriptionsRouteNames } from '@/router/routes-names'
import { Member } from '@/modules/members/types'
import { useRouter, useRoute } from 'vue-router'
import { useFormModule } from '@/modules/_shared/forms'
import { useFreeSubscriptionsModule } from '@/modules/free-subscriptions'
import QForm from 'quasar/src/components/form/QForm.js';
import moment from 'moment'

export default defineComponent({
    name: 'new-free-subscription-form',
    components: {
        FreeSubscriptionsFormFieldMember,
        FreeSubscriptionPickMemberDialog,
        FreeSubscriptionNewMemberDialog,
        FreeSubscriptionSearchForMemberDialog,
        FreeSubscriptionsFormFieldStartDate,
        FreeSubscriptionsFormFieldEndDate,
        FreeSubscriptionsFormFieldSubscriptionType,
        FreeSubscriptionsFormFieldProcessType,
        FormFieldPackages
    },
    setup () {
        const router = useRouter()
        const route = useRoute()
        const currentDate = moment().format('YYYY-MM-DD')

        const freeSubscriptionModel = reactive<AddFreeSubscription>({
            memberId: '',
            startDate: currentDate,
            endDate: '',
            subscriptionType: '',
            packages: []
        })

        const memberModel = reactive({
            email: '',
            firstName: '',
            lastName: ''
        })

        const showPickMemberDialog = ref(false)
        const showAddMemberDialog = ref(false)
        const showSearchForMemberDialog = ref(false)

        function showMemberDialog () {
            showPickMemberDialog.value = true
        }

        function onAddMember () {
            showPickMemberDialog.value = false
            showAddMemberDialog.value = true
        }

        function onSearchForMember () {
            showPickMemberDialog.value = false
            showSearchForMemberDialog.value = true
        }

        function assignAddedMember (member: Member) {
            showAddMemberDialog.value = false
            showSearchForMemberDialog.value = false
            freeSubscriptionModel.memberId = member.id
            memberModel.email = member.email
            memberModel.firstName = member.firstName
            memberModel.lastName = member.lastName
        }

        const { submitForm, createOnSuccess } = useFormModule()
        const { addFreeSubscription } = useFreeSubscriptionsModule()
        const form = ref<QForm>()

        const sendRequest = async () => addFreeSubscription(freeSubscriptionModel)
        const moveToList = () => router.push({ name: FreeSubscriptionsRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Free subscription added!')
        ).then(moveToList)

        const {
            validations: {
                requiredRule
            }
        } = useFormModule()

        return {
            freeSubscriptionModel,
            memberModel,
            onAddMember,
            onSearchForMember,
            assignAddedMember,
            showMemberDialog,
            showPickMemberDialog,
            showAddMemberDialog,
            showSearchForMemberDialog,
            onSubmit,
            requiredRule,
            form,
            FreeSubscriptionsRouteNames,
            route
        }
    }
})
